import styled from '@emotion/styled';
import { css } from '@emotion/react';

export type AlertVariant = 'info' | 'warning' | 'success' | 'danger' | 'neutral';
export type AlertSize = 'sm' | 'md';

type StyledProps = {
  $variant: AlertVariant;
  $size: AlertSize;
  $color?: string;
  $backgroundColor?: string;
  $borderColor?: string;
};

const palette: Record<AlertVariant, { bg: string; color: string; border: string }> = {
  info: { bg: '#E6EFFC', color: '#036BE1', border: '#B3D4FA' },
  warning: { bg: '#FFF8E6', color: '#8A6D1D', border: '#F8C953' },
  success: { bg: '#EAF7EE', color: '#2E7D32', border: '#40BC61' },
  danger: { bg: '#FCEDE9', color: '#C62828', border: '#EC4D2C' },
  neutral: { bg: '#F5F5F5', color: '#575757', border: '#E0E0E0' },
};

const sizeStyles: Record<AlertSize, ReturnType<typeof css>> = {
  sm: css`
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 6px;
    gap: 8px;
  `,
  md: css`
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 8px;
    gap: 12px;
  `,
};

export const StyledAlert = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StyledProps>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  line-height: 1.4;
  border: 1px solid
    ${({ $borderColor, $variant }) => $borderColor || palette[$variant].border};
  background-color: ${({ $backgroundColor, $variant }) =>
    $backgroundColor || palette[$variant].bg};
  color: ${({ $color, $variant }) => $color || palette[$variant].color};

  ${({ $size }) => sizeStyles[$size]}
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`;
